import { UserManager, WebStorageStateStore, UserManagerSettings } from 'oidc-client';
import { createUserManager } from 'redux-oidc';
import { AuthKeys } from '../dto/authorization/AuthKeys';

export const storage =
  process.env.REACT_APP_OAUTH_STORAGE === 'sessionStorage' ? window.sessionStorage : window.localStorage;

interface UserManagerSettingsOptions extends UserManagerSettings {
  resource: string;
  state: boolean;
}

export function isLoginRedirect() {
  const silentRenewUrl = checkFestoDomain(`${process.env.REACT_APP_OAUTH_SILENT_RENEW_URL}`, `${process.env.REACT_APP_OAUTH_SILENT_RENEW_CHINA_URL}`);
  const idpUrl = process.env.REACT_APP_OAUTH_ISSUER;

  return (
    idpUrl &&
    silentRenewUrl &&
    document.referrer &&
    (() => {
      const idp = new URL(idpUrl);
      const referrer = new URL(document.referrer);
      const issuer = new URL(silentRenewUrl);
      return (referrer.host === issuer.host && referrer.pathname.includes('login')) || referrer.host === idp.host;
    })()
  );
}

export function checkFestoDomain(defaultDomain: string, alternativeDomain: string) {
  const currentDomain = window.location.hostname;
  return currentDomain.includes('festo.com.cn') ? alternativeDomain : defaultDomain;
}

const settings: UserManagerSettingsOptions = {
  authority: `${process.env.REACT_APP_OAUTH_AUTHORITY}`,
  client_id: `${process.env.REACT_APP_OAUTH_CLIENT_ID}`,
  redirect_uri: checkFestoDomain(
    `${process.env.REACT_APP_OAUTH_CALLBACK_URL}`,
    `${process.env.REACT_APP_OAUTH_CALLBACK_CHINA_URL}`
  ),
  silent_redirect_uri: checkFestoDomain(
    `${process.env.REACT_APP_OAUTH_SILENT_RENEW_URL}`,
    `${process.env.REACT_APP_OAUTH_SILENT_RENEW_CHINA_URL}`
  ),
  popup_redirect_uri: checkFestoDomain(
    `${process.env.REACT_APP_OAUTH_LOGOUT_URL}`,
    `${process.env.REACT_APP_OAUTH_LOGOUT_CHINA_URL}`,
  ),
  response_type: `${process.env.REACT_APP_OAUTH_RESPONSE_TYPE}`,
  resource: `${process.env.REACT_APP_OAUTH_RESOURCE}`,
  scope: `${process.env.REACT_APP_OAUTH_SCOPE}`,
  automaticSilentRenew: false,
  state: true,
  loadUserInfo: false,
  userStore: new WebStorageStateStore({ store: storage }),
  silentRequestTimeout: 60000,
  metadata: {
    issuer: `${process.env.REACT_APP_OAUTH_ISSUER}`,
    jwks_uri: `${process.env.REACT_APP_OAUTH_JWKS_URI}`,
    end_session_endpoint: `${process.env.REACT_APP_OAUTH_END_SESSION_ENDPOINT}`,
    authorization_endpoint: `${process.env.REACT_APP_OAUTH_AUTHORIZATION_ENDPOINT}`,
    userinfo_endpoint: `${process.env.REACT_APP_OAUTH_USERINFO_ENDPOINT}`,
  },
};

const userManager = (keys?: AuthKeys[]): UserManager => {
  return createUserManager({ ...settings, signingKeys: keys !== undefined ? keys : undefined });
};

export default userManager;
